// src/components/filter.
import React, {
  useMemo,
  Button,
  useState,
  useEffect,
} from "react";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';
import { getAudittrial } from "service/api";

function DatatableTables() {

  const [country, setCountry] = useState([]);
  const [searchText, setSearchText] = useState("");

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     getAllCountry();
  //   }, 500);

  //   return () => clearInterval(intervalId);
  // }, []);
  useEffect(() => {
    let timeoutId;

    const fetchData = async () => {
      if (searchText === "") {
        console.log("Search text is empty, fetching data...");
        await getAllCountry();
        timeoutId = setTimeout(fetchData, 500); // Only start the next fetch if searchText is still empty
      } else {
        console.log("Search text is not empty, pausing data fetching.");
      }
    };

    fetchData(); // Initial fetch call

    // Cleanup function to clear the timeout when the component unmounts or when searchText changes
    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchText]);

  const handleSearchChange = (e) => {
    console.log("Search text changed:", e.target.value);
    setSearchText(e.target.value);
  };
  const getAllCountry = async () => {
    let response = await getAudittrial();
    setCountry(response.data);
    // console.log(response.data);
  }



  const columns = useMemo(
    () => [
      {
        Header: 'IP Address',
        accessor: 'ipAddress',
      },
      {
        Header: 'User Navigate To',
        accessor: 'resource'
      },
      {
        Header: 'Timestamp',
        accessor: 'timestamp'
      },
      {
        Header: 'Username',
        accessor: 'userName'
      },
      {
        Header: 'Practice name',
        accessor: 'clinic'
      },
      {
        Header: 'Role',
        accessor: 'role'
      },
      {
        Header: 'Agent',
        accessor: 'agent'
      },
      // {
      //   Header: 'userID',
      //   accessor: 'userid'
      // },
      {
        Header: 'action',
        accessor: 'action'
      },
    ],
    []
  );

  const data = [

  ];

  //meta title
  document.title = "Audittrial | List";

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1 className="page-title"></h1>
          {/* <Link to="/Addcountry" className="btn btn-primary">ADD NEW COUNTRY</Link> */}
        </div>
        <Breadcrumbs title="Setting" breadcrumbItem="Audit trial" />
        {/* <Table columns={columns} data={data} /> */}
        <TableContainer columns={columns} data={country} isGlobalFilter={true} isAddOptions={false} customPageSize={10}
          className="custom-header-css" onGlobalFilterChange={handleSearchChange}
          globalFilter={searchText} />
      </div>
    </div>
  );
}
DatatableTables.propTypes = {
  preGlobalFilteredRows: PropTypes.any,

};


export default DatatableTables;